export default "__VITE_ASSET__D_4xfC5S__"